function updateProductStickyBarVisibility() {
  var bar = document.getElementById("productStickyBar");
  var right = document.querySelector(".product-right-content");
  var outer = document.querySelector(".product-outer");
  if (!bar || !right) return;

  var footer = document.querySelector("footer") || document.querySelector('[class*="footer-group"]');
  var footerInView = false;
  if (footer) {
    var footerRect = footer.getBoundingClientRect();
    footerInView = footerRect.top < (window.innerHeight - 40);
  }

  var isMobile = window.innerWidth <= 768;
  var shouldShow;

  if (isMobile) {
    // Mobile: show by default, hide only when the actual ATC button or footer is in the viewport.
    var atc = document.getElementById("add-to-cart");
    var atcInView = false;
    if (atc) {
      var atcRect = atc.getBoundingClientRect();
      atcInView = atcRect.bottom > 0 && atcRect.top < window.innerHeight;
    }
    shouldShow = !atcInView && !footerInView;
  } else {
    // Desktop: unchanged — show only after the right content has scrolled past.
    var rect = right.getBoundingClientRect();
    var pastContent = rect.bottom < 0;
    shouldShow = pastContent && !footerInView;
  }

  bar.classList.toggle("is-visible", shouldShow);
  if (outer) outer.classList.toggle("product-outer--sticky-pad", shouldShow);
}

function syncProductStickyFromPack() {
  var bar = document.getElementById("productStickyBar");
  var scope = document.querySelector(".product-outer");
  if (!bar || !scope) return;

  var checked = scope.querySelector('input[name="pack"]:checked');
  var label = checked && checked.closest(".pack-option");
  if (!label) return;

  var subEl = label.querySelector(".variant-subtitle");
  var titleEl = label.querySelector(".variant-title");
  var parts = [];
  if (subEl && subEl.textContent.trim()) parts.push(subEl.textContent.trim().toUpperCase());
  if (titleEl && titleEl.textContent.trim()) parts.push(titleEl.textContent.trim().toUpperCase());
  var lineStr = parts.join(" | ");

  var cur = label.querySelector(".variant-price");
  var comp = label.querySelector(".variant-compprice");
  var priceEl = bar.querySelector("[data-sticky-price]");
  var compEl = bar.querySelector("[data-sticky-compare]");
  var variantEl = bar.querySelector("[data-sticky-variant]");

  if (variantEl) variantEl.textContent = lineStr;
  if (priceEl) priceEl.textContent = cur ? cur.textContent.trim() : "";

  if (compEl) {
    var compText = comp && comp.textContent ? comp.textContent.trim() : "";
    if (compText) {
      compEl.textContent = compText;
      compEl.removeAttribute("hidden");
    } else {
      compEl.textContent = "";
      compEl.setAttribute("hidden", "");
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  syncProductStickyFromPack();

  (function initProductStickyReveal() {
    var bar = document.getElementById("productStickyBar");
    var right = document.querySelector(".product-right-content");
    if (!bar || !right) return;

    var ticking = false;
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        updateProductStickyBarVisibility();
      });
    }

    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);
    updateProductStickyBarVisibility();
  })();

  let thumbSwiper;

  function initThumbSwiper() {
    if (window.innerWidth > 768) {
      if (!thumbSwiper) {
        thumbSwiper = new Swiper(".thumb-slider", {
          spaceBetween: 10,
          slidesPerView: 5,
          watchSlidesProgress: true,
          slideToClickedSlide: true, // IMPORTANT (thumbnail click)
          navigation: {
            nextEl: ".thumb-next",
            prevEl: ".thumb-prev",
          },
        });

        //  Reconnect thumbs after init
        if (mainSwiper) {
          mainSwiper.thumbs.swiper = thumbSwiper;
          mainSwiper.thumbs.init();
          mainSwiper.thumbs.update();
        }
      }
    } else {
      if (thumbSwiper) {
        thumbSwiper.destroy(true, true);
        thumbSwiper = null;
      }
    }
  }

  const mainSwiper = new Swiper(".main-slider", {
    spaceBetween: 10,
    loop: true,

    navigation: { // FIX: arrows not working
      nextEl: ".main-next",
      prevEl: ".main-prev",
    },

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    thumbs: {
      swiper: thumbSwiper, // initially null (handled later)
    },

    breakpoints: {
      0: {
        slidesPerView: 1.2,
        pagination: {
          enabled: true,
        },
      },
      769: {
        slidesPerView: 1,
        pagination: {
          enabled: false,
        },
      },
    },
  });

  initThumbSwiper();

  window.addEventListener("resize", function () {
    initThumbSwiper();
  });

});

// variant change — scope .active to the same pack list (PDP vs popup)
document.addEventListener("change", function (e) {
  if (!e.target.matches('input[name="pack"]')) return;

  var group = e.target.closest(".pack-variant-outer");
  if (group) {
    group.querySelectorAll(".pack-option").forEach(function (lbl) {
      lbl.classList.remove("active");
    });
  } else {
    document.querySelectorAll(".pack-option").forEach(function (lbl) {
      lbl.classList.remove("active");
    });
  }

  var parentLabel = e.target.closest(".pack-option");
  if (parentLabel) {
    parentLabel.classList.add("active");
  }

  syncProductStickyFromPack();
});

// Add to checkout code start here

/**
 * @param {HTMLElement | null} button
 * @param {boolean} isLoading
 */
function setCustomAddButtonState(button, isLoading) {
  if (!button) return;

  if (isLoading) {
    button.classList.add("is-loading");
    button.style.pointerEvents = "none";
    button.style.opacity = "0.6";
    button.setAttribute("aria-busy", "true");
    if (button instanceof HTMLButtonElement) button.disabled = true;
    return;
  }

  button.classList.remove("is-loading");
  button.style.pointerEvents = "";
  button.style.opacity = "";
  button.removeAttribute("aria-busy");
  if (button instanceof HTMLButtonElement) button.disabled = false;
}

function getCartSectionIds() {
  return Array.from(document.querySelectorAll("cart-items-component"))
    .reduce((ids, component) => {
      if (component instanceof HTMLElement && component.dataset.sectionId) {
        ids.push(component.dataset.sectionId);
      }
      return ids;
    }, /** @type {string[]} */ ([]));
}

/**
 * @param {Record<string, any>} cartResponse
 * @param {string[]} sectionIds
 */
function broadcastCartUpdate(cartResponse, sectionIds) {
  document.dispatchEvent(
    new CustomEvent("cart:update", {
      bubbles: true,
      detail: {
        resource: cartResponse,
        sourceId: "custom-product-add",
        data: {
          source: "custom-product-add",
          itemCount: 1,
          sections: cartResponse?.sections || Object.fromEntries(sectionIds.map((id) => [id, ""])),
        },
      },
    })
  );
}

function openCartDrawer() {
  const drawer = /** @type {any} */ (document.querySelector("cart-drawer-component"));
  if (drawer && typeof drawer.open === "function") {
    drawer.open();
  }
}

document.addEventListener('change', function(e) {

  const packRadio = e.target.closest('input[name="pack"]');

  if (!packRadio) return;
  const variants = window.productData.variants;
  // Collect selected option values
  const selectedOptions = [];

  document.querySelectorAll('[name^="options["]').forEach(option => {
    selectedOptions.push(option.value);
  });

  // Replace the first option (Pack) with the clicked pack value
  const selectedVariant = variants.find(
    variant => variant.id == packRadio.value
  );

  if (!selectedVariant) return;

  selectedOptions[0] = selectedVariant.option1;

  // Find matching variant
  const matchedVariant = variants.find(variant => {

    return variant.options.every((option, index) => {
      return option === selectedOptions[index];
    });

  });

  if (!matchedVariant) return;

  const variantSelect = document.querySelector('select[name="id"]');

  variantSelect.value = matchedVariant.id;

  variantSelect.dispatchEvent(
    new Event('change', { bubbles: true })
  );

});

document.addEventListener("click", function(e) {
  const target = e.target;
  if (!(target instanceof Element)) return;

  // BUY NOW / SHOP NOW (main + sticky bar)
  if (target.closest("#add-to-cart") || target.closest("#add-to-cart-sticky")) {
    const clickedButton = target.closest("#add-to-cart, #add-to-cart-sticky");
    if (!(clickedButton instanceof HTMLElement)) return;

    const selectedInput = /** @type {HTMLInputElement | null} */ (
      document.querySelector('[name="id"]')
    );

    if (!selectedInput) {
      alert("Please select a pack");
      return;
    }

    const selectedVariant = selectedInput.value;
    const sectionIds = getCartSectionIds();
    setCustomAddButtonState(clickedButton, true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: selectedVariant,
        quantity: 1,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      })
    })
    .then(res => res.json())
    .then(data => {
      broadcastCartUpdate(data, sectionIds);
      openCartDrawer();
    })
    .catch(err => {
      console.error("Error:", err);
    })
    .finally(() => {
      setCustomAddButtonState(clickedButton, false);
    });

  }

});

